<template>
  <div class="receiptActionBar">
    <button class="iconButton check" :disabled="disabled || saving || !canSaveAll" @click="onSave">
      <b-spinner v-if="saving" small class="mr-1"></b-spinner>
      {{ $t('receiptMatcher.save') }}
    </button>
    <button class="iconButton arrowUp" :disabled="disabled || saving || !canImportAll" @click="onImport">
      {{ sheetType === 'inbound' ? $t('receiptMatcher.importInvoice') : $t('receiptMatcher.importSheet') }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'ReceiptActionBar',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    canImportAll: {
      type: Boolean,
      default: false,
    },
    canSaveAll: {
      type: Boolean,
      default: false,
    },
    saving: {
      type: Boolean,
      default: false,
    },
    sheetType: {
      type: String,
      default: 'outbound',
    },
  },
  methods: {
    onImport() {
      this.$emit('import')
    },
    onSave() {
      this.$emit('save')
    },
  },
}
</script>

<style scoped>
.receiptActionBar {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;
  margin-top: 20px;
  padding: 20px 0 10px;
  border-top: 1px solid #333;
}

/* The global button.iconButton styles (main.css) provide the base look.
   These scoped rules add the icon for the check (save) and last-import
   (import) buttons, since they are not defined globally. */
.receiptActionBar button.iconButton.check:before {
  background-image: url("../../assets/img/icon-check.svg");
}

.receiptActionBar button.iconButton.arrowUp:before {
  background-image: url("../../assets/img/icon-arrow-up.svg");
}

.receiptActionBar button.iconButton:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>